import { EReportTypes } from 'entities/Report';
import { i18n } from 'i18n';

export const REPORT_TYPES = () => ({
	[EReportTypes.DATE]: i18n.t('Группировать по времени'),
	[EReportTypes.OFFER]: i18n.t('Группировать по офферам'),
	[EReportTypes.SOURCE]: i18n.t('Группировать по площадкам'),
	[EReportTypes.ACTION]: i18n.t('Группировать по заявкам'),
});
